import { DialogModal } from '@client/components/DialogModal';
import { SeatExpirationCard } from './SeatExpirationCard';
import { Button } from '@/components/ui/button';
import { useEditSeatExpiration } from './useEditSeatExpiration';

interface EditSeatExpirationDialogProps {
  open: boolean;
  onClose: () => void;
  seat: {
    subscriptionSeatId: string;
    advisorName: string | null;
    advisorEmail: string | null;
    invitedEmail: string | null;
  };
  onSave?: (seatId: string, expirationDate: string | null) => void;
  initialExpiresDateTime?: Date | null;
}

export function EditSeatExpirationDialog({
  open,
  onClose,
  seat,
  onSave,
  initialExpiresDateTime,
}: EditSeatExpirationDialogProps) {
  const { expirationValue, setExpirationValue, handleSave } = useEditSeatExpiration({
    onSave,
    initialExpiresDateTime,
  });

  const handleSaveClick = () => {
    handleSave(seat.subscriptionSeatId);
    onClose();
  };

  const userName = seat.advisorName || 'Invited User';
  const userEmail = seat.advisorEmail || seat.invitedEmail || '';

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title="Edit Seat Expiration"
      subTitle={`Advisor: ${userName}${userEmail ? ` (${userEmail})` : ''}`}
      width="md"
      primaryButton={
        <div className="flex justify-end gap-3">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="px-8"
            onClick={handleSaveClick}
          >
            Save
          </Button>
        </div>
      }
    >
      <div className="mt-6">
        <SeatExpirationCard
          value={expirationValue}
          onChange={setExpirationValue}
        />
      </div>
    </DialogModal>
  );
}
